import { eventsSlice } from "./eventsSlice";
import { settingsSlice } from "./settingsSlice";
import { statisticsSlice } from "./statisticsSlice";
import { fetchStatistics } from "./statisticsSlice";
import { addNote, fetchNotesByEventId, notesSlice, updateNote, deleteNote } from "@src/store/notesSlice";
import { fetchReports, reportsSlice } from "@src/store/reportsSlice";
import { exclusionRulesSlice, fetchExclusionRules } from "@src/store/exclusionRulesSlice";
import { poMappingSlice, getPOData, getPOMappingSuggestions } from "@src/store/poMappingSlice";
import {
	addVenueAlias,
	deleteVenueAliases,
	fetchVenueAliasGroups,
	searchVenueAliasCandidates,
} from "@src/store/venueAliasesSlice";

export const settingsActions = {
	...settingsSlice.actions,
};

export const statisticsActions = {
	...statisticsSlice.actions,
	fetchStatistics,
};

export const eventsActions = {
	...eventsSlice.actions,
};

export const reportsActions = {
	...reportsSlice.actions,
	fetchReports,
};

export const notesActions = {
	...notesSlice.actions,
	fetchNotesByEventId,
	addNote,
	updateNote,
	deleteNote,
};

export const exclusionRulesActions = {
	...exclusionRulesSlice.actions,
	fetchExclusionRules,
};

export const poMappingActions = {
	...poMappingSlice.actions,
	getPOData,
	getPOMappingSuggestions,
};

export const venueAliasesActions = {
	fetchVenueAliasGroups,
	searchVenueAliasCandidates,
	addVenueAlias,
	deleteVenueAliases,
};
